import React from 'react'
import PropTypes from 'prop-types'
import upperCase from 'lodash/upperCase'
import {useTranslation} from 'react-i18next'
import AuditAdminMenu from '../../AuditAdminMenu'
import {AuditContext} from '../../../context/Audits'
import {TemplatesContext} from '../../../context/Templates'
import {AuditPaneContext} from '../../../context/AuditPane'
import {UserContext} from '../../../context/User'
import lowerCase from 'lodash/lowerCase'
import {MDBTable, MDBTableHead, MDBTableBody} from 'mdbreact'
import Spinner from 'react-bootstrap/Spinner'
const statusValues = {
  completed: 'green',
  incomplete: 'green',
  open: 'blue',
}

function TableAudits({currentTemplate}) {
  const {t} = useTranslation()

  const {templateAudits, getAudits} = React.useContext(TemplatesContext)
  const {selectAudit, audit} = React.useContext(AuditContext)

  const user = React.useContext(UserContext)
  const paneState = React.useContext(AuditPaneContext)
  const [searchParams, setSearchParams] = React.useState({
    column_name: 'name',
    sort_by: 'asc',
  })
  const permission = (user.details && user.details.canCreate) || false

  React.useEffect(() => {
    getAudits({template_id: currentTemplate.id, ...searchParams})
  }, [currentTemplate.id, getAudits, searchParams])

  const handleSort = column_name => {
    let sort_by
    if (searchParams.column_name !== column_name) {
      sort_by = 'asc'
    } else {
      sort_by = searchParams.sort_by === 'asc' ? 'desc' : 'asc'
    }

    setSearchParams({...searchParams, column_name, sort_by})
  }

  const handleRecordSelect = data => {
    if (audit === null || (audit && audit.selected && audit.selected.id) !== data.id) {
      selectAudit(data)
    }
    paneState.isExpandOpen && !paneState.isSidebarOpen && paneState.openSidebar('audit')
  }

  const pillbox = due_status => {
    const due = lowerCase(due_status).replace(' ', '_')
    const pillVariants = {
      due_soon: 'yellow',
      new: 'blue',
      incomplete: 'red',
    }

    return (
      due && (
        <span
          className={
            `ap-pillbox ml_5` +
            `${pillVariants[due_status] ? ` ap-pillbox--${pillVariants[due_status]}` : ''}` +
            ` ap-pillbox--shrink`
          }
        ></span>
      )
    )
  }

  const bubble = content => <span className="ap-bubble ml_5">{content}</span>
  const sortHeader = (param, width = 0, className = '') => (
    <th
      className={
        'audit-table__header audit-icon--sort' +
        `${
          searchParams.column_name === param
            ? searchParams.sort_by === 'asc'
              ? ' audit-icon--sort-asc'
              : ' audit-icon--sort-desc'
            : ''
        }` +
        ` width_${width}` +
        `${className ? ` ${className}` : ''}`
      }
      onClick={() => handleSort(param)}
    >
      {upperCase(t(`audit.table.columns.${param}`))}
    </th>
  )

  return (
    <div className="audit-expand__column audit-expand__column--table template-expand__audit--table">
      <MDBTable className="audit-table">
        <MDBTableHead>
          <tr className="audit-table__row audit-table__row--head audit-table__row--gray cursor_pointer">
            {sortHeader('name', 15, 'audit-table__cell--expand')}
            <th className="audit-table__header width_11">
              {upperCase(t('audit.table.columns.status'))}
            </th>
            <th className="audit-table__header width_15">
              {upperCase(t('audit.table.columns.assignee'))}
            </th>
            <th className="audit-table__header width_11">
              {upperCase(t('audit.table.columns.start_date'))}
            </th>
            <th className="audit-table__header width_11">
              {upperCase(t('audit.table.columns.finished_date'))}
            </th>
            <th className="audit-table__header width_11">
              {upperCase(t('audit.table.columns.due_date'))}
            </th>
            <th className="audit-table__header width_5"></th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {templateAudits.isLoading ? (
            <tr className="border_none">
              <td colSpan={permission ? '7' : '6'} className="text_center">
                <Spinner className="audit-spinner" animation="border" role="status" />
              </td>
            </tr>
          ) : templateAudits && templateAudits.audits && templateAudits.audits.length > 0 ? (
            templateAudits &&
            templateAudits.total_audits > 0 &&
            templateAudits.audits.map(data => (
              <tr
                key={data.id}
                className="audit-table__row audit-table__row--no-border-top cursor_pointer"
              >
                <td
                  className="audit-table__cell audit-table__cell--expand"
                  onClick={() => handleRecordSelect(data)}
                >
                  <div title={data.name} className="overflow-content">
                    {data.name}
                  </div>
                  {pillbox(data.due_status)}
                </td>
                <td
                  className={
                    'audit-table__cell width_11' +
                    `${(statusValues[data.status] &&
                      ` audit-table__cell--${statusValues[data.status]}`) ||
                      ''}`
                  }
                  onClick={() => handleRecordSelect(data)}
                >
                  {(statusValues[data.status] && t(`audit.table.status.${data.status}`)) ||
                    t(`audit.table.status.scheduled`)}
                </td>
                <td className="audit-table__cell width_15" onClick={() => handleRecordSelect(data)}>
                  {data.audit_users_attributes.length > 1 ? (
                    <>
                      {`${data.audit_users_attributes[0].user_name}, `}
                      {bubble(`+${data.audit_users_attributes.length - 1}`)}
                    </>
                  ) : data.audit_users_attributes.length !== 0 ? (
                    data.audit_users_attributes[0].user_name
                  ) : (
                    ''
                  )}
                </td>
                <td className="audit-table__cell width_11" onClick={() => handleRecordSelect(data)}>
                  {data.start_date}
                </td>
                <td className="audit-table__cell width_11" onClick={() => handleRecordSelect(data)}>
                  {data.start_date}
                </td>
                <td className="audit-table__cell width_11" onClick={() => handleRecordSelect(data)}>
                  {data.due_date && data.due_date !== '12/31/2100' && data.due_date}
                </td>
                <td className="audit-table__cell audit-table__cell--right width_5">
                  {permission &&
                    (data.audit_type_for_user === 'created' || user.details.is_admin) && (
                      <AuditAdminMenu data={data} expand />
                    )}
                </td>
              </tr>
            ))
          ) : (
            <tr
              className="audit-table__row--none audit-table__row--no-border-bottom"
              style={{display: 'grid'}}
            >
              <td
                colSpan={permission ? '7' : '6'}
                className="audit-table__cell--none audit-table__cell--gray audit-table__cell--expand"
              >
                {templateAudits &&
                templateAudits.total_audits === 0 &&
                searchParams.query === '' &&
                searchParams.due_filter === '0' ? (
                  <>
                    <span className="font_20">
                      {t('audit.tab.none.created')}
                      <br />
                      {permission && t('audit.tab.none.suggestion')}
                    </span>
                    <br />
                    {permission && (
                      <button
                        className="audit-button audit-button--blue mt_20"
                        onClick={() => paneState.openModal()}
                      >
                        {t('audit.button.create')}
                      </button>
                    )}
                  </>
                ) : (
                  <span className="font_20"> {t('audit.tab.none.found')}</span>
                )}
              </td>
            </tr>
          )}
        </MDBTableBody>
      </MDBTable>
    </div>
  )
}

TableAudits.propTypes = {
  audit: PropTypes.shape({}).isRequired,
}

TableAudits.displayName = 'TableAudits'

export default TableAudits
